export default "__VITE_ASSET__gwxOFlx3__"